'use client'
import { getCookie } from 'cookies-next'
import { NavigationGuardProvider } from 'next-navigation-guard'
import posthog from 'posthog-js'
import { PostHogProvider as PostHog } from 'posthog-js/react'
import { Suspense } from 'react'
import { env } from '@/env/client'
import PostHogPageView from './page-view'

// Initialize PostHog
if (typeof window !== 'undefined' && env.NEXT_PUBLIC_PRODUCTION_MODE) {
  const getBootstrapData = () => {
    try {
      const flags = getCookie('bootstrapData') as string
      if (!flags) return {}
      return JSON.parse(flags)
    } catch (error) {
      return {}
    }
  }

  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: `${env.NEXT_PUBLIC_BASE_URL}/ingest`,
    ui_host: env.NEXT_PUBLIC_POSTHOG_HOST,
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    bootstrap: getBootstrapData(),
    capture_exceptions: true,
  })

  //   Enable debug mode in development
  //   if (!env.NEXT_PUBLIC_DEVELOPMENT_MODE) posthog.debug()
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!env.NEXT_PUBLIC_PRODUCTION_MODE) return children
  return (
    <NavigationGuardProvider>
      <PostHog client={posthog}>
        <Suspense children={<PostHogPageView />} />
        {children}
      </PostHog>
    </NavigationGuardProvider>
  )
}
